/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useTranslation } from "react-i18next";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";

// Estilos del footer
import styles from "customAssets/customStyleFooter.js";

// Asset de logos institucionales
import logosFoot from "customAssets/banda_logos_completa_2.png";

const useStyles = makeStyles(styles);

/**
 * Footer principal de la aplicación.
 *
 * Esta versión:
 * - elimina el banner de cookies del footer
 * - deja el footer como bloque institucional puro
 * - mantiene estructura semántica y responsive
 *
 * Importante:
 * - El banner de cookies ya NO debe renderizarse aquí.
 * - Ahora vive a nivel de layout global (Main.js).
 */
export default function WebFooter(props) {
  const { t } = useTranslation("home");
  const classes = useStyles();
  const { fluid, white } = props;

  /**
   * El proyecto usa normalmente el modo fluid para este footer.
   * Mantenemos la misma API por compatibilidad.
   */
  const containerClassName = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white,
  });

  return (
    <footer className={classes.footer} role="contentinfo" id="app-footer">
      <div className={containerClassName}>
        {/*
          Bloque textual principal del footer.
          Aquí ya solo queda el disclaimer institucional.
        */}
        <div className={classes.textFoot}>
          {t("disclaimer")}
        </div>

        {/*
          Bloque de logos institucionales.
          Se mantiene separado del texto para que el CSS
          pueda centrarlo o apilarlo por breakpoint.
        */}
        <div className={classes.logoFoot}>
          <div className={classes.left}>
            <img
              src={logosFoot}
              alt={t("footer-logos-alt", {
                defaultValue: "Financiación EU INCIBE",
              })}
            />
          </div>
        </div>
      </div>
    </footer>
  );
}

WebFooter.propTypes = {
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool,
};